import React from 'react';
import { Button, Form } from 'antd';
import {
  ButtonGroup,
  Drawer,
  RejectionDrawerValues,
  RejectionForm,
} from '@common/components';
import { useComplianceItemAction } from '@onboarding/hooks';

export function ComplianceItemRejectionDrawer({
  open,
  onClose,
  complianceItemId = '',
}: {
  open: boolean;
  onClose: () => void;
  complianceItemId?: string;
}) {
  const [form] = Form.useForm();

  const onCloseDrawer = () => {
    form.resetFields();
    onClose();
  };

  const [performAction, { loading: rejectionLoading }] =
    useComplianceItemAction({ onFinished: onCloseDrawer });

  const onReject = (input: RejectionDrawerValues) => {
    performAction({
      variables: {
        id: complianceItemId,
        input: {
          action: 'reject',
          reason: input.rejectionReason,
          rejectionDetails: input.rejectionComment,
        },
      },
    });
  };

  return (
    <Drawer
      open={open}
      onClose={onCloseDrawer}
      className="compliance-item-rejection-drawer"
      title="Reject Compliance Item"
      footer={
        <ButtonGroup>
          <Button size="large" onClick={onCloseDrawer}>
            Cancel
          </Button>
          <Button
            danger
            type="primary"
            size="large"
            loading={rejectionLoading}
            onClick={form.submit}
          >
            Reject
          </Button>
        </ButtonGroup>
      }
    >
      <RejectionForm
        form={form}
        onRejectClick={onReject}
        reasonsListQuery="WorksListItemRejectionReasons"
      />
    </Drawer>
  );
}
